import EventEmitter from '../Utils/EventEmitter';
import Events from '../Utils/Events.js';

export default class Menu {
    constructor(canvas) {
        this.eventEmitter = new EventEmitter();
        this.canvas = canvas;
        this.menuToggle = document.querySelector('.menu-toggle');
        this.menuDiv = document.querySelector('.menu');
        this.teleportMenuItems = document.querySelectorAll('.teleport');
        this.roomWaypointsIndices = [0, 3, 7];

        this.setupListeners();
    }

    setupListeners() {
        this.onMenuToggle = () => {
            this.menuDiv.classList.toggle('show-menu');
        };
        this.onCanvasClick = () => {
            this.menuDiv.classList.remove('show-menu');
        };
        this.onTeleportMenuItemCallbacks = [];

        this.menuToggle.addEventListener('click', this.onMenuToggle);
        this.canvas.addEventListener('mousedown', this.onCanvasClick);
        this.canvas.addEventListener('touchstart', this.onCanvasClick);

        for (let i = 0; i < this.teleportMenuItems.length; i += 1) {
            this.onTeleportMenuItemCallbacks[i] = () =>
                this.eventEmitter.trigger(Events.TELEPORT, [
                    this.roomWaypointsIndices[i],
                ]);
            this.teleportMenuItems[i].addEventListener(
                'click',
                this.onTeleportMenuItemCallbacks[i]
            );
        }
    }

    destroy() {
        this.menuToggle.removeEventListener('click', this.onMenuToggle);
        this.canvas.removeEventListener('mousedown', this.onCanvasClick);
        this.canvas.removeEventListener('touchstart', this.onCanvasClick);
        for (let i = 0; i < this.teleportMenuItems.length; i += 1) {
            this.teleportMenuItems[i].removeEventListener(
                'click',
                this.onTeleportMenuItemCallbacks[i]
            );
        }
        this.menuDiv.remove();
    }
}
